var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxboldfolderUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.9,4.4c-0.5-0.1-1-0.2-1.5-0.2H14c-0.1,0,0,0-0.1,0c-0.1,0-0.2-0.1-0.2-0.1 c-0.5-0.7-1.2-1.6-1.2-1.6c-0.1-0.1-0.1-0.1-0.1-0.2C12.3,2.1,12.3,2,12.6,2c0.9,0,3,0,3,0c1.7,0,3.1,0.9,3.9,2.3 c0.1,0.2,0,0.3-0.2,0.2C19.1,4.4,19,4.4,18.9,4.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7,5.9c-0.4-0.1-0.7-0.1-1.1-0.1h-3.7c-0.6,0-0.6-0.1-0.9-0.5l-1.4-1.9C10.9,2.5,10.4,2,8.7,2H6.4 C4,2,2,4,2,6.4v11.2C2,20,4,22,6.4,22h11.2c2.4,0,4.4-2,4.4-4.4v-7.4c0-1.5-0.7-2.8-1.9-3.6C19.7,6.2,19.2,6,18.7,5.9z M14.1,11 c0,1.2-0.9,2.1-2.1,2.1l0,0l0,0c0,0,0,0-0.1,0c-1.2,0-2.1-1-2.1-2.1c0-1.2,0.9-2.1,2.1-2.1S14.1,9.8,14.1,11z M12,18.8 c-0.8,0-1.6-0.2-2.2-0.6c-0.6-0.4-0.9-0.9-0.9-1.5s0.3-1.1,0.9-1.5c1.2-0.8,3.2-0.8,4.4,0c0.6,0.4,0.9,0.9,0.9,1.5 s-0.3,1.1-0.9,1.5C13.6,18.6,12.8,18.8,12,18.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxboldfolderUser);
export default __webpack_public_path__ + "static/media/vuesaxboldfolder-user.f867b4f45f136a5a91ee5bd8fa2b081d.svg";
export { ForwardRef as ReactComponent };